import { useContext } from "react";
import AchievementUI from "../components/achievementUI/AchievementUI";
import { AppLayout } from "../layout/AppLayout";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../components/context/UseContext";
import { Avatar } from "../components/Avatar";

function Achievements() {
  const navigate = useNavigate();
  const { profile } = useContext(UserContext);

  return (
    <AppLayout bg={"!bg-[#F8F8F8]"}>
      <div className="pt-10 px-4">
        <header className="flex justify-between mb-8 items-center">
          <h3 className="text-3xl font-bold">Achievements</h3>
          {profile?.profile_image ? (
            <div
              onClick={() => navigate("/settings/profile")}
              className="p-0.5 border-gradient rounded-full w-fit cursor-pointer"
            >
              <img
                className="w-10 h-10 object-cover rounded-full"
                src={profile?.profile_image}
                alt="Profile_image"
                loading="lazy"
              />
            </div>
          ) : (
            <Avatar
              onClick={() => navigate("/settings/profile")}
              firstName={profile?.first_name}
              lastName={profile?.last_name}
            />
          )}
        </header>
      </div>
      <div className="container px-0 pb-16 h-full">
        <AchievementUI />
      </div>
    </AppLayout>
  );
}

export default Achievements;
